import { createApp, h, type Component, nextTick } from "vue";
import { hideModal } from "@/App/utils/showBootstrapModal";

export function mountModal<TProps extends Record<string, unknown>>(
  modalComponent: Component<TProps>,
  props: TProps & {
    modalId: string;
    onConfirm?: () => void;
    onClose?: () => void;
  },
) {
  const container = document.createElement("div");
  document.body.appendChild(container);

  let app: ReturnType<typeof createApp> | null = null;

  const cleanupAndUnmount = () => {
    if (!container.isConnected) {
      return;
    }

    app?.unmount();
    container.remove();
    props.onClose?.();
  };

  app = createApp({
    render() {
      return h(modalComponent, {
        ...props,
        onCancel: () => {},
        onConfirm: () => {
          props.onConfirm?.();
          hideModal({ modalId: props.modalId });
        },
      });
    },
  });

  app.mount(container);

  nextTick(() => {
    const rootEl = container.querySelector(".modal");
    if (rootEl) {
      rootEl.addEventListener("hidden.bs.modal", cleanupAndUnmount, { once: true });
    }
  });
}
